export default __webpack_public_path__ + "static/media/i2.eb25d5c5.png";